<template>
  <div class="row reverse-mobile">
    <div class="col-12 col-md-3">
      <UserMenu></UserMenu>
    </div>
    <div class="col-12 col-md-9">
      <div class="d-flex flex-row align-items-center">
        <i class="material-icons material-icons-title mr-2"
          >insert_chart_outlined</i
        >
        <h2 class="mt-2">Scenario Upload</h2>
      </div>
      <p>Share your corpuls simulation content.</p>
      <p>
        By default, your scenarios will be unpublished and only visible to you.
      </p>
      <div v-bind:class="{ 'd-none': isOnNative }">
        <form enctype="multipart/form-data">
          <vue-dropzone
            ref="dropzone"
            id="drop1"
            :options="dropOptions"
            v-on:vdropzone-file-added="fileAdded"
            :useCustomSlot="true"
          >
            <p>{{ dropText }}</p>
          </vue-dropzone>
        </form>
      </div>

      <p class="upload-warning" v-if="displayUploadWarning">
        Note: uploading a folder only searches one level deep
      </p>
      <div class="d-flex flew-row" v-if="isOnNative">
        <a class="mr-2">
          <button
            class="btn btn-primary d-flex align-items-center justify-content-center d-inline-block"
            @click="requestNativeScenarios"
          >
            <i class="material-icons mr-1">import_export</i>
            Import from corpuls simulation
          </button>
        </a>
        <a v-if="uploadObjects.length > 0" class="mr-2">
          <button
            class="btn btn-primary d-flex align-items-center justify-content-center d-inline-block"
            @click="selectAll"
          >
            <i class="material-icons mr-1">select_all</i>
            Select all
          </button>
        </a>
        <a v-if="uploadObjects.length > 0 && !uploadStarted" class="mr-2">
          <button
            class="btn btn-success d-flex align-items-center justify-content-center d-inline-block"
            @click="uploadSelectedClicked"
          >
            <i class="material-icons mr-1">cloud_upload</i>
            Upload Selected
          </button>
        </a>
      </div>
      <div class="container-table-row" v-if="uploadObjects.length > 0">
        <div class="container-table-cell">
          <table class="table table-responsive">
            <thead>
              <tr>
                <th>ID</th>
                <th v-if="isOnNative">Upload</th>
                <th>File</th>
                <th>Message</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="file in uploadObjects">
                <th scope="row">{{ file.id + 1 }}</th>
                <td class="text-center" v-if="isOnNative">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="file.toggledForUpload"
                    value
                    id="index"
                  />
                </td>
                <td>{{file.humanName}}</td>
                <td class="text-left" v-if="file.hasUploaded">
                  <span class="font-italic">Upload complete</span>
                </td>
                <td class="text-left" v-else-if="file.hasErrors">
                  <span class="font-italic">{{ file.errorMessage }}</span>
                </td>

                <td
                  class="text-center d-flex justify-content-center align-items-center"
                  v-if="file.hasUploaded"
                >
                  <i class="material-icons mr-1 text-success">check_circle</i>
                </td>
                <td
                  class="text-center d-flex justify-content-center align-items-center"
                  v-else-if="file.hasErrors"
                >
                  <i class="material-icons mr-1 text-danger">error</i>
                </td>
                <td
                  class="text-center d-flex justify-content-center align-items-center"
                  v-else-if="
                    !file.hasUploaded &&
                      !file.hasErrors &&
                      file.toggledForUpload &&
                      uploadStarted
                  "
                >
                  <img
                    class="uploading-file-spinner"
                    src="../assets/uploading-file-spinner.gif"
                    alt="uploading, please wait"
                  />
                </td>
                <td
                  class="text-center d-flex justify-content-center align-items-center"
                  v-else
                ></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <p class="disclaimer mt-3">
        <em></em>
      </p>
    </div>
  </div>
</template>

<script>
import scenService from "./../services/scenarios.service";
import UserMenu from "../components/UserMenu";
import ScenarioToUploadObject from "../objects/ScenarioToUploadObject";
import vueDropzone from "vue2-dropzone";

export default {
  name: "ScenarioUpload",
  data: function() {
    return {
      dropText:
        "Drop your files here to upload to Community, or click to browse.",
      uploadObjects: [],
      uploadStarted: false,
      scenarioPath: "",
      dropOptions: {
        url: "none",
        autoProcessQueue: false,
        maxFilesize: 512, // MB
        maxFiles: 10,
        addRemoveLinks: true
      },
      displayUploadWarning: false
    };
  },

  computed: {
    isOnNative() {
      return this.$store.getters.getIsOnNative;
    }
  },

  components: {
    UserMenu,
    vueDropzone
  },

  beforeMount() {
    this.registerNativeMethodPointers();
  },

  methods: {
    registerNativeMethodPointers() {
      window.updateAvaiableScenarios = this.updateAvaiableScenarios;
      window.setScenariosPath = this.setScenariosPath;
      window.recieveScenario = this.recieveScenario;
    },

    requestNativeScenarios() {
      this.resetUploadState();

      window.webkit.messageHandlers.scenarioexport.postMessage("request");
      window.webkit.messageHandlers.getscenariospath.postMessage("request");
    },

    updateAvaiableScenarios(response) {
      this.createNativeUploadObjects(JSON.parse(response).scenarioList);
    },

    createNativeUploadObjects(scenarios) {
      let compoundIndex = 0;

      scenarios.forEach((scenario, index) => {
        if (scenario.type === "folder" && scenario.children.length > 0) {
          scenario.children.forEach(childScenario => {
            if (childScenario.type === "folder") return; // Only want depth of 1

            this.uploadObjects.push(
              new ScenarioToUploadObject(
                compoundIndex,
                childScenario.itemPath,
                childScenario.itemName,
                this.scenarioPath
              )
            );

            compoundIndex++;
          });

          return;
        }

        this.uploadObjects.push(
          new ScenarioToUploadObject(
            compoundIndex,
            scenario.itemPath,
            scenario.itemName,
            this.scenarioPath
          )
        );

        compoundIndex++;
      });
    },

    createNoneNativeUploadObjects(fileNames) {
      for (let index = 0; index < fileNames.length; index++) {
        this.uploadObjects.push(
          new ScenarioToUploadObject(
            index,
            '',
            fileNames[index].name,
            this.scenarioPath,
            true
          )
        );
      }
    },

    uploadSelectedClicked() {
      this.uploadStarted = true;
      this.uploadObjects = this.uploadObjects.filter(function(object) {
        return object.toggledForUpload === true;
      });

      this.uploadObjects.forEach(object => {
        this.processUploadObject(object);
      });
    },

    processUploadObject(object) {
      window.webkit.messageHandlers.getscenariofile.postMessage({
        fullPath: this.scenariosPath + "/" + object.name,
        relPath: "corpuls-scenarios/" + object.name,
        id: object.id
      });
    },

    recieveScenario(recivedBase64, receivedCallBackId) {
      let receivedObject = this.uploadObjects.find(
        object => object.id === parseInt(receivedCallBackId)
      );

      let blob = this.base64ToBlob(recivedBase64, "zip, application/zip");
      let receivedObjectFile = new File([blob], receivedObject.name.replace('.json', '.isims'));
      this.sendOffScenario(receivedObjectFile);
    },

    base64ToBlob(base64Data, mimeType) {
      base64Data = base64Data.replace(/^[^,]+,/, "");
      mimeType = mimeType || "";

      let sliceSize = 1024;
      let byteCharacters = atob(base64Data);
      let bytesLength = byteCharacters.length;
      let slicesCount = Math.ceil(bytesLength / sliceSize);
      let byteArrays = new Array(slicesCount);

      for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
        let begin = sliceIndex * sliceSize;
        let end = Math.min(begin + sliceSize, bytesLength);
        let bytes = new Array(end - begin);

        for (let offset = begin, i = 0; offset < end; ++i, ++offset) {
          bytes[i] = byteCharacters[offset].charCodeAt(0);
        }

        byteArrays[sliceIndex] = new Uint8Array(bytes);
      }
      return new Blob(byteArrays, { type: mimeType });
    },

    fileAdded(file) {
      this.displayUploadWarning = false;
      if (
        file.hasOwnProperty("fullPath") &&
        file.fullPath.split("/").length > 2
      ) {
        // Too deep... ignore it
        this.$refs.dropzone.removeFile(file);
        this.displayUploadWarning = true;
        return;
      }

      this.uploadStarted = true;

      this.uploadObjects.push(
        new ScenarioToUploadObject(
          this.uploadObjects.length,
          '',
          file.name,
          this.scenarioPath,
          true
        )
      );

      this.sendOffScenario(file);
    },

    filesDroppedNoneNative() {
      this.resetUploadState();
      this.uploadStarted = true;
      let files = this.$refs.scenarioFiles.files;
      this.createNoneNativeUploadObjects(files);
      for (let i = 0; i < files.length; i++) {
        this.sendOffScenario(files[i]);
      }
    },

    sendOffScenario(fileToSend) {
      let formData = new FormData();
      formData.append("scenFiles[]", fileToSend);
      this.uploadFormData(formData);
    },

    uploadFormData(formData) {
      scenService.uploadScenario(formData).then(response => {
        response.errors.forEach(error => {
          this.processUploadError(error);
        });

        response.successes.forEach(success => {
          this.processUploadSuccess(success);
        });
      });
    },

    processUploadError(error) {
      const dropzoneFiles = this.$refs.dropzone.getQueuedFiles();

      this.uploadObjects.forEach(object => {
        if (error.filename == object.humanName) {
          object.hasErrors = true;
          object.errorMessage = error.message;

          // NOTE: I don't know why, but .hasErrors is *not* reactive, yet .hasUploaded is.
          // Have tested in Vue Chrome console with the same result.
          object.hasUploaded = true;
          object.hasUploaded = false;

          let badDropFile = dropzoneFiles.find(file => file.name === object.humanName);
          this.$refs.dropzone.removeFile(badDropFile);
        }
      });
    },

    processUploadSuccess(success) {
      this.uploadObjects.forEach(object => {
        let objectFilename = object.name.replace(/^.*[\\\/]/, "");
        objectFilename = objectFilename.replace('.json', '.isims');

        if (success.filename == object.humanName || success.filename == objectFilename) {
          object.hasUploaded = true;
        }
      });
    },

    selectAll() {
      this.uploadObjects.forEach(object => {
        object.toggledForUpload = true;
      });
    },

    setScenariosPath(path) {
      this.scenarioPath = path;
    },

    resetUploadState() {
      this.uploadObjects = [];
      this.uploadStarted = false;
    }
  }
};
</script>

<style scoped>
.material-icons-title {
  font-size: 50px;
  color: #7d7d7d;
}
.table td {
  min-height: 20px;
}
tr.success {
  color: green;
}

tr.error {
  color: red;
}
.dropbox {
  outline: 2px dashed grey; /* the dash box */
  outline-offset: -10px;
  color: dimgray;
  padding: 10px 10px;
  min-height: 200px; /* minimum height */
  position: relative;
  cursor: pointer;
}

.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  height: 200px;
  position: absolute;
  cursor: pointer;
}

.dropbox:hover {
  background: #efefef;
}

.dropbox p {
  font-size: 1.2em;
  text-align: center;
  position: absolute;
  text-align: center;
  top: 40%;
  width: 100%;
}

.upload-warning {
  color: red;
  text-align: center;
}

.dz-message p {
  margin-bottom: 0;
  font-size: 1.2em;
}

.upload-message {
}
.upload-message.success {
  color: green;
}
.upload-message.error {
  color: red;
}

.disclaimer {
  font-size: 0.8rem;
}

.container-table {
  display: table;
}

.container-table-row {
  display: table-row;
}

.container-table-cell {
  display: table-cell;
}

.thead {
  color: #CB2E37;
}

tr {
  min-height: 75px;
}

.uploading-file-spinner {
  height: 25px;
  width: auto;
  -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
  filter: grayscale(100%);
}
</style>
